import { render, staticRenderFns } from "./OrderTab.vue?vue&type=template&id=2c8c6982&scoped=true&"
import script from "./OrderTab.vue?vue&type=script&lang=js&"
export * from "./OrderTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c6982",
  null
  
)

export default component.exports